module.exports = __webpack_public_path__ + "static/media/img3.6af370b6.png";